import { createAction, props } from '@ngrx/store';

import {
  InstallationCollection,
  InstallationsMigrationListQueryParams,
  MigrateInstallationsQueryParams,
} from '@vi-iot/client';

export namespace InstallationsMigrationActions {
  export enum Type {
    SET_CUSTOMER_NUMBER = '[MIGRATE INSTALLATIONS] Set customer number',
    SET_NEW_CUSTOMER_NUMBER = '[MIGRATE INSTALLATIONS] Set new customer number',
    SET_INSTALLATIONS_TO_MIGRATE = '[MIGRATE INSTALLATIONS] Set installations to migrate',
    GET_CUSTOMER_COMPANY_NAMES = '[MIGRATE INSTALLATIONS] Get customer company names',
    GET_CUSTOMER_COMPANY_NAMES_SUCCESS = '[MIGRATE INSTALLATIONS] Get customer company names success',
    GET_CUSTOMER_COMPANY_NAMES_ERROR = '[MIGRATE INSTALLATIONS] Get customer company names error',
    LIST_COMPANY_CUSTOMER_INSTALLATONS = '[MIGRATE INSTALLATIONS] List company customer installations',
    LIST_COMPANY_CUSTOMER_INSTALLATONS_SUCCESS = '[MIGRATE INSTALLATIONS] List company customer installations success',
    LIST_COMPANY_CUSTOMER_INSTALLATONS_ERROR = '[MIGRATE INSTALLATIONS] List company customer installations error',
    CLEAR_CACHED_DATA = '[MIGRATE INSTALLATIONS] Clear cached data',
    MIGRATE_INSTALLATIONS = '[MIGRATE INSTALLATIONS] Migrate installations',
    MIGRATE_INSTALLATIONS_SUCCESS = '[MIGRATE INSTALLATIONS] Migrate installations success',
    MIGRATE_INSTALLATIONS_ERROR = '[MIGRATE INSTALLATIONS] Migrate installations error',
    CLEAR_CACHED_INSTALLATIONS = '[MIGRATE INSTALLATIONS] Clear cached installations',
    CLEAR_LOADED_INSTALLATIONS = '[MIGRATE INSTALLATIONS] Clear loaded installations',
  }

  export const setCustomerNumber = createAction(
    Type.SET_CUSTOMER_NUMBER,
    props<{
      customerNumber: string;
    }>()
  );

  export const setNewCustomerNumber = createAction(
    Type.SET_NEW_CUSTOMER_NUMBER,
    props<{
      newCustomerNumber: string;
    }>()
  );

  export const clearCachedInstallations = createAction(Type.CLEAR_CACHED_INSTALLATIONS);

  export const setInstallationsToMigrate = createAction(
    Type.SET_INSTALLATIONS_TO_MIGRATE,
    props<{
      installationsToMigrate: string[];
    }>()
  );

  export const getCustomerCompanyNames = createAction(
    Type.GET_CUSTOMER_COMPANY_NAMES,
    props<{
      customerNumber: string;
      newCustomerNumber: string;
    }>()
  );

  export const getCustomerCompanyNamesSuccess = createAction(
    Type.GET_CUSTOMER_COMPANY_NAMES_SUCCESS,
    props<{
      customerCompanyName: string;
      newCustomerCompanyName: string;
    }>()
  );

  export const getCustomerCompanyNamesError = createAction(Type.GET_CUSTOMER_COMPANY_NAMES_ERROR);

  export const listCompanyCustomerInstallations = createAction(
    Type.LIST_COMPANY_CUSTOMER_INSTALLATONS,
    props<{
      params: InstallationsMigrationListQueryParams;
    }>()
  );

  export const listCompanyCustomerInstallationsSuccess = createAction(
    Type.LIST_COMPANY_CUSTOMER_INSTALLATONS_SUCCESS,
    props<{
      installations: InstallationCollection[];
      cursor: string;
    }>()
  );

  export const listCompanyCustomerInstallationsError = createAction(
    Type.LIST_COMPANY_CUSTOMER_INSTALLATONS_ERROR
  );

  export const migrateInstallations = createAction(
    Type.MIGRATE_INSTALLATIONS,
    props<{
      params: MigrateInstallationsQueryParams;
    }>()
  );

  export const migrateInstallationsSuccess = createAction(Type.MIGRATE_INSTALLATIONS_SUCCESS);

  export const migrateInstallationsError = createAction(Type.MIGRATE_INSTALLATIONS_ERROR);

  export const clearCachedData = createAction(Type.CLEAR_CACHED_DATA);

  export const clearLoadedInstallations = createAction(Type.CLEAR_LOADED_INSTALLATIONS);
}
